import React, { useCallback, useMemo } from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { Theme } from "styles/theme";
import { GUILD_ROLES_EMOJIS } from "config/consts";
import { useSelectedGuildRole } from "hooks/useSelectedGuildRole";
import { WalletContentDisplayLocations } from "./WalletAddressLabel";

export interface GuildRoleProps {
  displayLocation: WalletContentDisplayLocations;
  isVisible?: boolean;
}

export type GuildClassMap = Record<"wrapper" | "span", string | undefined>;

export const GuildRole: React.FC<GuildRoleProps> = props => {
  const theme = GlobalStore.useState(s => s.theme);
  const selectedRole = useSelectedGuildRole();

  const getGuildStyles = useCallback(
    (
      theme: Theme
    ): Record<WalletContentDisplayLocations, Record<string, React.CSSProperties | undefined>> => {
      return {
        [WalletContentDisplayLocations.Sidenav]: {
          wrapper: undefined,
          span: { fontWeight: 500, color: "#CCD1D1", lineHeight: "16px", fontSize: "12px" },
        },
        [WalletContentDisplayLocations.Header]: { wrapper: {}, span: {} },
        [WalletContentDisplayLocations.WalletView]: {
          span: undefined,
          wrapper: { backgroundColor: theme.surface.alt.primary.default },
        },
        [WalletContentDisplayLocations.NavbarV2]: {
          wrapper: undefined,
          span: undefined,
        },
        [WalletContentDisplayLocations.NavbarV2Mobile]: {
          wrapper: undefined,
          span: {
            color: theme.font.secondary.default,
            fontSize: theme.fontSize[4],
            lineHeight: theme.lineHeights["4"],
          },
        },
      };
    },
    []
  );

  const guildStyles = getGuildStyles(theme);

  const Wrapper = useMemo(() => {
    if (guildStyles[props.displayLocation].wrapper != null) {
      return ({ children }: React.PropsWithChildren) => {
        return <div style={guildStyles[props.displayLocation].wrapper}>{children}</div>;
      };
    }
  }, [guildStyles, props.displayLocation]);

  if (props.isVisible === false) {
    return null;
  }

  if (selectedRole == null) {
    return null;
  }

  const RoleIcon = GUILD_ROLES_EMOJIS[selectedRole.id];
  const content = (
    <span
      style={{ ...guildStyles[props.displayLocation].span, display: "flex", alignItems: "center" }}
    >
      {selectedRole.name}
      {RoleIcon && <RoleIcon width={18} height={18} color={theme.font.secondary.default} />}
    </span>
  );

  return <>{Wrapper ? <Wrapper>{content}</Wrapper> : content}</>;
};
